import React from 'react';
import { connect } from 'react-redux';
import { getTranslatedString } from 'helpers/i18n';
import Form from 'components/ui/Form';
import PropertyMultiselectAdvanced from 'components/shared/PropertyMultiselectAdvanced';

const PropertyInput = ({ values, errors, touched, setFieldValue, properties }) => {
  const handleChange = (properties) => {
    let setProperties = properties || [];
    setProperties = Array.isArray(setProperties) ? setProperties : [setProperties];
    setFieldValue('properties', setProperties);
  };

  const renderInputControl = () => {
    return (
      <PropertyMultiselectAdvanced
        name="properties"
        onChange={handleChange}
        value={values.properties}
        error={touched.properties && errors.properties}
      />
    );
  };

  if (!values.assign_to_properties) return null;

  return (
    <Form.Item label={getTranslatedString('landlordPortal.noticeAssignmentForm.properties')}>
      {renderInputControl()}
    </Form.Item>
  );
};

export default connect((store) => {
  return {
    properties: store.landlordProperties.properties,
  };
}, {})(PropertyInput);
